import Container from '@mui/material/Container';

import ImpersonatePatientForm from '../../components/admin/ImpersonatePatientForm';
import AppDashboard from '../AppDashboard';

const AssumePatientRolePage = () => {
  return (
    <AppDashboard>
      <Container maxWidth='xs' sx={{paddingTop: '2em'}}>
        <ImpersonatePatientForm />
      </Container>
    </AppDashboard>
  );
};

export default AssumePatientRolePage;